import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/TestimonialsPage.css";

const clientLogos = [
  "/wp-content/uploads/2016/03/logo1.jpg",
  "/wp-content/uploads/2016/03/logo3.jpg",
  "/wp-content/uploads/2016/03/logo2.jpg",
  "/wp-content/uploads/2016/03/logo4.jpg",
  "/wp-content/uploads/2016/03/logo5.jpg",
  "/wp-content/uploads/2016/03/logo6.jpg",
  "/wp-content/uploads/2016/03/logo7.jpg",
  "/wp-content/uploads/2016/03/logo8.jpg",
  "/wp-content/uploads/2016/03/logo9.jpg",
  "/wp-content/uploads/2016/03/logo10.jpg",
  "/wp-content/uploads/2016/03/logo11.jpg",
  "/wp-content/uploads/2016/03/logo12.jpg",
  "/wp-content/uploads/2016/03/logo13.jpg",
  "/wp-content/uploads/2016/03/logo14.jpg",
  "/wp-content/uploads/2016/03/logo15.jpg",
];

const sliderSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};

const TestimonialsPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [mobileLogoIndex, setMobileLogoIndex] = useState(0);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const nextLogo = () => {
    setMobileLogoIndex((prev) => (prev + 1) % clientLogos.length);
  };

  const prevLogo = () => {
    setMobileLogoIndex((prev) =>
      prev === 0 ? clientLogos.length - 1 : prev - 1
    );
  };

  const testimonials = [
    {
      id: 1,
      content: `
        It is indeed a pleasure to know that Colombo Dockyard Plc Ltd (Colombo Dockyard) has completed 20 years of association with Onomichi Dockyard Company Ltd of Japan.

        In the competitive and fast changing world of Offshore Logistics, owning quality, technologically advanced and cost effective assets have been a critical factor in the 7 year journey of Greatship as a quality service provider to our clients. Colombo Dockyard Plc Ltd has played a crucial role in this achievement. Greatship's association with Colombo Dockyard started in 2006 when we were looking for competent shipyards in Asia for construction of vessels under our new build programme. Our first DP II vessel was delivered to us in January 2008. The association has continued to flourish over the years, resulting in Colombo Dockyard delivering a total of 4 AHTS and 7 ROV Support Vessels, the last being Greatship Ragini delivered a month ago.

        During our association with Colombo Dockyard, we found them to be professional, highly quality conscious and they were able to deliver our vessels in accordance to our contract. These vessels continue to provide efficient service to our clients and have thus earned praise and trust for their reliability. We have no doubt that Onomichi Dockyard Company Limited's collaboration with Colombo Dockyard has been responsible for their perseverance to achieve superior quality during construction which is important for vessel owners.

        Flexibility to meet owner's needs is another positive trait that we experienced in Colombo Dockyard's approach to vessel building. In offshore business some of the charters have additional demands to enhance vessel's capability. We found Colombo Dockyard to be capable and accommodating in meeting these changing requirements.

        We wish Colombo Dockyard and Onomichi Dockyard Company's association the very best and hope they will continue to build quality vessels as one of the better yards in the sub-continent.
      `,
      author: "Ravi Sheth",
      title: "Managing Director, Greatship India Limited",
    },
    {
      id: 2,
      content: `
        In February 2012 Titan Fleet Management approached Colombo Dockyard PLC with a proposal to carry out a 10-year class survey, hull repairs and a full exterior re-spray of the 90m passenger yacht Lauren L. After much discussion we were reassured by the capabilities of the yard and decided to go ahead with the works in, what was at the time, an unproven super yacht facility. However, after 38 days, the survey and all projects were complete ahead of our original 60-day schedule, leaving Lauren L to continue her Indian Ocean cruising itinerary as planned.

        In working closely with Colombo Dockyard PLC, and in particular Mr. Dhammika Dissanayake (Senior Ship Manager), I have found this facility to be most accommodating of all our needs in the large refit project. All of our projects were very well managed by the technical team, who met with the Titan Fleet team on a daily basis, they worked well in conjunction with our Technical Superintendent Mr. Christophe Niekrasz, who was particularly impressed with the work of Mr. G A Amila Rukshan (Estimating and Invoicing Engineer). Although we used our own paint team to complete the exterior paint works I was pleased with this yard's flexibility and professionalism in allowing us to do so.

        It was due to this successful experience, excellent client based approach and convenient location that Lauren L returned to Sri Lanka in April 2012. The yacht required some modification carried out on a tight schedule to allow time to return to the Mediterranean for a busy summer season. Colombo Dockyard PLC were able to rearrange other projects to accept Lauren L at very short notice. Once again all works were complete within schedule (43 days), a testament to the immense and skilled workforce of over 4000 individuals.

        I would like to thank Mr. Darshana Chandrasekera (Head of Marketing, Ship Repairs) and the team at Colombo Dockyard PLC for all their cooperation and assistance in the past, and look forward to working closely with them in the future.
      `,
      author: "Nick Sevier",
      title: "Titan Fleet Management",
    },
    {
      id: 3,
      content: `
        Bourbon Offshore has been patronising Colombo Dockyard PLC over the past decade for our repair requirements especially for our fleet stationed in the Indian Subcontinent and Far East Region.

        Colombo's strategic geographic location, speed of repairs, quality of service and convenience of logistics (ship spares) are all unique features that are essential for the ship owner for a fast turn around and quality repair job.

        We have always had good experiences with the repair projects carried out at Colombo, with the Colombo Dockyard team being reliable and flexible to accommodate our challenging last minute requirements.

        Colombo Dockyard has been recognised as a key repair center for offshore vessels and Bourbon Offshore will have Colombo as a preferred repair location within our system.

        At this special occasion of celebrating 20 years of collaboration with Onomichi Dockyard Co. Ltd, we wish the Colombo Dockyard Team all the best and great future.
      `,
      author: "Rajiv Tewani",
      title: "Managing Director, Bourbon Offshore MMI",
    },
    {
      id: 4,
      content: `
        Colombo Dockyard PLC has been very dear to us, to almost all shipping companies operating in Maldives. Frankly speaking, we would not sustain our aged fleet of vessels without the skill of the yard and its technical assistance, whether it be in seeking to fulfill a regulatory obligation of a normal docking to any requested standard or in undertaking an emergency repair.

        Our choice has always been Colombo Dockyard, not for its proximity, but because it is flexible and client oriented it is easy to deal with, simple to communicate, and most important of all, we are able to accomplish what we go there for. A factual experience over the years is that the yard has neither disappointed the ship owner nor the technical team at the end of the day.
      `,
      author: "Hussain Shareef",
      title: "Technical Superintendent, Lily Shipping",
    },
    {
      id: 5,
      content: `
        It gives us great pleasure to congratulate Colombo Dockyard on the 20th Anniversary of their collaboration with Onomichi Dockyard Japan. Chris Marine having been exclusive agents in Greece for Colombo Dockyard over the past 30 years, have had the pleasure of working with one of the most professional Shipyards in the world.

        Chris Marine has seen Colombo Dockyard accomplish numerous highly specialised repair jobs, conversions and newbuildings, including offshore projects, with repeat clients from all over the world. Colombo Dockyard, having joined forces in 1993 with Onomichi Dockyard of Japan, has excelled tremendously and has become one of the most important shiprepairers in the area, competing with larger and older yards in the region. One must also mention the fact that Colombo Dockyard always strives to achieve customer satisfaction no matter how small or large a project is.

        We are proud to be part of the history of Colombo Dockyard and wish you continuous future success and expansion.

        Please accept our warmest Congratulations on your 20th Anniversary of your collaboration with Onomichi Dockyard.
      `,
      author: "Christos Papatheodorou and Kimon Papatheodorou",
      title: "Exclusive Agents of Colombo Dockyards in Greece CHRIS MARINE SA",
    },
  ];

  return (
    <>
      <Header />

      <div className="testimonials-wrapper" id="testimonials-page">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>What our client says…</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            What our client says…
          </h1>

          {testimonials.map((testimonial, idx) => (
            <div
              key={testimonial.id}
              className={`testimonial-block ${
                idx % 2 === 0 ? "left-accent" : "right-accent"
              }`}
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div className="testimonial-card">
                <div className="testimonial-content" data-aos="fade-up">
                  {testimonial.content.split("\n\n").map((para, i) => (
                    <p key={i}>{para.trim()}</p>
                  ))}
                </div>

                <div className="testimonial-author" data-aos="fade-up">
                  <strong>{testimonial.author}</strong>
                  <br />
                  <span>{testimonial.title}</span>
                </div>
              </div>
            </div>
          ))}

          <div className="separator"></div>

          <h2 className="clients-title" data-aos="fade-right">
            Our Clients
          </h2>

          {isMobile ? (
            <div className="mobile-client-slider">
              <button
                type="button"
                className="mobile-client-arrow left"
                onClick={prevLogo}
              >
                ‹
              </button>

              <div className="mobile-client-logo">
                <img src={clientLogos[mobileLogoIndex]} alt="Client logo" />
              </div>

              <button
                type="button"
                className="mobile-client-arrow right"
                onClick={nextLogo}
              >
                ›
              </button>
            </div>
          ) : (
            <Slider {...sliderSettings} className="client-slider">
              {clientLogos.map((logo, idx) => (
                <div key={idx} className="client-logo">
                  <img src={logo} alt={`Client logo ${idx + 1}`} />
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default TestimonialsPage;